import { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAccountId } from "resources/account"
import { getSortedModels } from "resources/models"
import { getModel } from "modules/home-layout/selectors/model"
import { Creators } from "modules/home-layout/model"
import ModelWrapper from "connected-components/model-wrapper"
import PreferenceContext from "hooks/preferences"
import { AiTeammateProvider } from "connected-components/ai-teammate/context"
import { ThreadsProvider } from "connected-components/ai-teammate/context/threads"
import { MessagesProvider } from "connected-components/ai-teammate/context/messages"
import { AiTeammateAnalyticsProvider } from "connected-components/ai-teammate/analytics"
import ChatWorkspace from "./components/workspace"
import "./style.scss"

export default function AgentChat() {
  const accountId = useAccountId()
  const dispatch = useDispatch()
  // The risk model is the account's global selected model — getModel falls back to a default model, so one is always selected once the list loads.
  const modelId = useSelector(getModel)
  const models = useSelector(getSortedModels)
  const modelName = useMemo(() => models.find((model) => model.id === modelId)?.name ?? "", [models, modelId])
  const setModel = useCallback((id) => dispatch(Creators.setModel(id)), [dispatch])

  // This page does not persist anything to user preferences (persistPreferences={false} below).
  // The provider stays mounted only so the now-disabled preference hooks have a context to read;
  // no preferences API calls are made.
  const preferencesProps = useMemo(() => ({
    accountId,
    key: "agent-chat",
    type: "ai-teammate",
  }), [accountId])

  return <PreferenceContext.Provider value={preferencesProps}>
    <AiTeammateProvider managedAgent persistPreferences={false} modelId={modelId}>
      <ThreadsProvider persistPreferences={false}>
        <AiTeammateAnalyticsProvider>
          <MessagesProvider>
            <div className="agent-chat-page">
              {/* ModelWrapper is rendered childless on purpose: here it is just the risk-model selector
                  bar. The chat is a sibling, not its child, so the conversation is not gated on model
                  loading/access (you can read history while models resolve). */}
              <ModelWrapper modelId={modelId} modelName={modelName} setModel={setModel} />
              <ChatWorkspace />
            </div>
          </MessagesProvider>
        </AiTeammateAnalyticsProvider>
      </ThreadsProvider>
    </AiTeammateProvider>
  </PreferenceContext.Provider>
}
